import { render, staticRenderFns } from "./TsQrCode.vue?vue&type=template&id=5f89db97&scoped=true"
import script from "./TsQrCode.vue?vue&type=script&lang=js"
export * from "./TsQrCode.vue?vue&type=script&lang=js"
import style0 from "./TsQrCode.vue?vue&type=style&index=0&id=5f89db97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89db97",
  null
  
)

export default component.exports